<div class="directorio-container">
    <p class="title-directorio">Directorio</p>
    <div class="search-gerente">
        <label class="search-text">Buscar por estado</label>
        <div class="search-cont">
            <div class="custom-select-wrapper" style="width: 259px; height: 50px; margin: 0;" [class.open]="openedSelect === 'estado'">
                <div class="custom-select-display" (click)="toggleEstado()" style="width: 259px; height: 50px;">
                    <div class="custom-select-text ">
                        <label class="custom-select-label" [class.float]="!!selectedEstadoNombre">
                            Estado
                        </label>
                        <span class="selected-value" *ngIf="selectedEstadoNombre">
                            {{ selectedEstadoNombre }}
                        </span>
                    </div>
                    <img src="Inmuebles/assets/iconos/vector.svg" class="arrow"
                        [style.transform]="'rotate(' + estadoRotation + 'deg)'"
                        [style.transition]="'transform 0.3s ease'">
                </div>

                <ul class="custom-select-options" style="width: 259px;" *ngIf="openedSelect === 'estado'">
                    <li (click)="selectEstadoDirectorio(0, 'Todos')">Todos</li>
                    <li *ngFor="let estado of estados" (click)="selectEstadoDirectorio(estado.idEstado, estado.nombre)">
                        {{ estado.nombre }}
                    </li>
                </ul>
            </div>
            <div class="btn-wrapper">
                <button class="btn" (click)="buscarPorEstado()">
                    <span class="btn-text">Buscar</span>
                    <img src="Inmuebles/assets/iconos/search_icon.svg" class="btn-icon" alt="Lupa" />
                </button>
            </div>
        </div>
    </div><br><br>

    <!-- Tabla del directorio -->
    <table class="table">
        <thead>
            <tr>
                <th class="col-estado" (click)="ordenarPor('estadoCobertura')">
                    Estado
                    <img src="Inmuebles/assets/iconos/arrow-table.svg" alt="Ordenar" class="sort-icon"
                        [ngClass]="{ 'rotated': campoOrden === 'estadoCobertura' && ordenAscendente }" />
                </th>
                <th class="col-gerente" (click)="ordenarPor('nombreGerente')">
                    Gerente
                    <img src="Inmuebles/assets/iconos/arrow-table.svg" alt="Ordenar" class="sort-icon"
                        [ngClass]="{ 'rotated': campoOrden === 'nombreGerente' && ordenAscendente }" />
                </th>
                <th class="col-contacto">Contacto</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let c of contactosFiltrados">
                <td class="table-content align-middle">{{ c.estadoCobertura }}</td>
                <td class="table-content align-middle">{{ capitalizeFirstLetter(c.nombreGerente) }}</td>
                <td class="align-middle">
                    <a (click)="abrirModal(c.id)" class="btn-detalle d-inline-block">Contactar</a>
                </td>
            </tr>
        </tbody>
    </table>

    <div class="empty-container" *ngIf="mostrarSpinner">
        <img class="search-spinner" src="Inmuebles/assets/iconos/spinner.gif" />
    </div>

    <div class="empty-container" *ngIf="mostrarEmptyState">
        <div class="empty-image-container">
            <img src="Inmuebles/assets/iconos/empty_state.svg" />
        </div>
        <div class="empty-text">
            <div class="empty-title">Aún no realizas una búsqueda.</div>
            <div class="empty-subtitle">Inicia la búsqueda por Estado.</div>
        </div>
    </div>

    <div class="empty-container" *ngIf="mostrarSinResultados">
        <div class="empty-image-container">
            <img src="Inmuebles/assets/iconos/empty_state.svg" />
        </div>
        <div class="empty-text">
            <div class="empty-title">No encontramos resultados para tu búsqueda en este Estado.</div>
            <div class="empty-subtitle">Verifica el Estado seleccionado o intenta con otra opción.</div>
        </div>
    </div>

    <div class="paginador-wrapper">
        <div class="paginador-container" *ngIf="totalFilas > 11">

            <div class="paginador-select">
                <label class="text-selectFilas" for="selectFilas">Filas por página</label>
                <select class="select-filas" id="selectFilas" [(ngModel)]="filasSeleccionadas"
                    (change)="cambiarFilasPorPagina()">
                    <option *ngFor="let filas of opcionesFilas" [value]="filas">{{ filas }}</option>
                </select>
            </div>

            <div class="paginador-rango">
                {{ desdeFila }}-{{ hastaFila }} de {{ totalFilas }}
            </div>

            <div class="paginador-botones">
                <button [disabled]="paginador.first" (click)="prepararRequest(0)">
                    <img src="Inmuebles/assets/iconos/top-left.svg" alt="Primera página">
                </button>
                <button [disabled]="paginador.first" (click)="prepararRequest(paginador.number - 1)">
                    <img src="Inmuebles/assets/iconos/left.svg" alt="Anterior">
                </button>
                <button [disabled]="paginador.last" (click)="prepararRequest(paginador.number + 1)">
                    <img src="Inmuebles/assets/iconos/right.svg" alt="Siguiente">
                </button>
                <button [disabled]="paginador.last" (click)="prepararRequest(paginador.totalPages - 1)">
                    <img src="Inmuebles/assets/iconos/top-right.svg" alt="Última página">
                </button>
            </div>

        </div>
    </div>
</div>
<!-- Botón para visualizar el formulario 

 <div class="text-end mb-3">
    <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#contactoModal">
        Visualizar Formulario
    </button>
</div>  -->

<!-- Modal de Contacto -->
<div #contactarModal class="modal fade" id="contactoModal" tabindex="-1" role="dialog"
    aria-labelledby="contactoModalLabel" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered form-modal">
        <div class="modal-content modal-custom-content">
            <div class="modal-header">
                <div class="w-100">
                    <button type="button" (click)="limpiarForm()" class="close-button" aria-label="Cerrar" data-bs-dismiss="modal">
                        <img src="Inmuebles/assets/iconos/close-button.svg" alt="Cerrar">
                    </button>
                    <p class="text-center mb-4 from-title">¡Contáctanos!</p>
                    <p class="texto-from" style="text-align: center;">Un gerente inmobiliario te podrá acompañar en
                        todos los trámites para adquirir una propiedad.</p>
                </div>
            </div>
            <div class="modal-body">
                <form autocomplete="off" [formGroup]="formSolicitudGen" (ngSubmit)="guardarGerentes()">
                    <!-- Busco Información de -->
                    <div class="col-auto" style="min-width: 290px;">
                        <div class="custom-select-wrapper" [class.open]="openedSelect === 'buscoinformacion'">
                            <div class="custom-select-display" (click)="toggleSelect('buscoinformacion')">
                                <div class="custom-select-text">
                                    <label class="custom-select-label" [class.float]="!!selectedInformacionText">
                                        Busco información de*
                                    </label>
                                    <span class="selected-value" *ngIf="selectedInformacionText">
                                        {{ selectedInformacionText }}
                                    </span>
                                </div>
                                <img src="Inmuebles/assets/iconos/vector.svg" class="arrow"
                                    [style.transform]="'rotate(' + informacionRotation + 'deg)'"
                                    [style.transition]="'transform 0.3s ease'">
                            </div>
                            <ul class="custom-select-options" *ngIf="openedSelect === 'buscoinformacion'">
                                <li (click)="selectInformacionD('Proceso de venta','Proceso de venta')">Proceso de venta
                                </li>
                                <li (click)="selectInformacionD('Otro','Otro')">Otro</li>
                            </ul>
                        </div>
                    </div>
                    <!-- Folio -->
                    <div class="">
                        <div class="input-wrapper">
                            <input type="text" class="custom-input" formControlName="folio" placeholder=" "
                                maxlength="5" pattern="[0-9]{5}" inputmode="numeric" (keydown)="soloNumeros($event)">
                            <label class="floating-label">Folio del Inmueble*</label>
                            <div class="form-text d-flex justify-content-between" style="margin-top: 7px;">
                                <span class="select-indicator">Número a 5 dígitos</span>
                                <span class="select-indicator">{{formSolicitudGen.get('folio')?.value?.length ||
                                    0}}/5</span>
                            </div>
                        </div>
                    </div>
                    <!-- Nombre -->
                    <div class="">
                        <div class="input-wrapper" [class.error]="formSolicitudGen.get('nombre')?.touched && formSolicitudGen.get('nombre')?.errors && formSolicitudGen.get('nombre')?.value">
                            <input type="text" class="custom-input" formControlName="nombre" maxlength="50" placeholder=" " (keypress)="soloLetras($event)">
                            <label class="floating-label" [attr.readonly]="isReadonly ? true : null"
                                (focus)="disableReadonly($event)">Nombre(s)*</label>
                            <div *ngIf="formSolicitudGen.get('nombre')?.touched && formSolicitudGen.get('nombre')?.errors">
                                <label class="helper-error" *ngIf="formSolicitudGen.get('nombre')?.errors?.['longitud']">
                                    Ingresa un nombre con más de 2 caracteres.
                                </label>
                                <label class="helper-error" *ngIf="formSolicitudGen.get('nombre')?.errors?.['repetidos']">
                                    No repitas caracteres seguidos.
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- APELLIDO PATERNO -->
                    <div class="">
                        <div class="input-wrapper" [class.error]="formSolicitudGen.get('paterno')?.touched && formSolicitudGen.get('paterno')?.errors && formSolicitudGen.get('paterno')?.value">
                            <input type="text" class="custom-input" formControlName="paterno" maxlength="50" placeholder=" " (keypress)="soloLetras($event)">
                            <label class="floating-label" [attr.readonly]="isReadonly ? true : null"
                                (focus)="disableReadonly($event)">Apellido 1*</label>
                            <div *ngIf="formSolicitudGen.get('paterno')?.touched && formSolicitudGen.get('paterno')?.errors">
                                <label class="helper-error" *ngIf="formSolicitudGen.get('paterno')?.errors?.['longitud']">
                                    Ingresa un apellido con más de 2 caracteres.
                                </label>
                                <label class="helper-error" *ngIf="formSolicitudGen.get('paterno')?.errors?.['repetidos']">
                                    No repitas caracteres seguidos.
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- APELLIDO MATERNO -->
                    <div class="">
                        <div class="input-wrapper" [class.error]="formSolicitudGen.get('materno')?.touched && formSolicitudGen.get('materno')?.errors && formSolicitudGen.get('materno')?.value">
                            <input type="text" class="custom-input" formControlName="materno" maxlength="50" placeholder=" " (keypress)="soloLetras($event)">
                            <label class="floating-label" [attr.readonly]="isReadonly ? true : null"
                                (focus)="disableReadonly($event)">Apellido 2 (Opcional)</label>
                            <div *ngIf="formSolicitudGen.get('materno')?.touched && formSolicitudGen.get('materno')?.errors">
                                <label class="helper-error" *ngIf="formSolicitudGen.get('materno')?.errors?.['longitud']">
                                    Ingresa un apellido con más de 2 caracteres.
                                </label>
                                <label class="helper-error" *ngIf="formSolicitudGen.get('materno')?.errors?.['repetidos']">
                                    No repitas caracteres seguidos.
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- Correo -->
                    <div class="">
                        <div class="input-wrapper">
                            <input type="email" class="custom-input" formControlName="correo" placeholder=" ">
                            <label class="floating-label" [attr.readonly]="isReadonly ? true : null"
                                (focus)="disableReadonly($event)">Correo electrónico*</label>
                        </div>
                    </div>
                    <!-- Teléfono celular -->
                    <div class="">
                        <div class="input-wrapper" [class.error]="formSolicitudGen.get('telefonocelular')?.touched && formSolicitudGen.get('telefonocelular')?.errors && formSolicitudGen.get('telefonocelular')?.value">
                            <input type="tel" class="custom-input" formControlName="telefonocelular" placeholder=" "
                                inputmode="numeric" pattern="[0-9]*" maxlength="10" (keypress)="soloNumeros($event)">
                            <label class="floating-label" [attr.readonly]="isReadonly ? true : null"
                                (focus)="disableReadonly($event)">Teléfono móvil*</label>
                            <div *ngIf="formSolicitudGen.get('telefonocelular')?.touched && formSolicitudGen.get('telefonocelular')?.errors">
                                <label class="helper-error" *ngIf="formSolicitudGen.get('telefonocelular')?.errors?.['repetidos5']">
                                    No repitas el mismo dígito más de 5 veces seguidas.
                                </label>
                                <label class="helper-error" *ngIf="formSolicitudGen.get('telefonocelular')?.errors?.['telefonoInvalido']">
                                    Ingresa el teléfono móvil a 10 dígitos.
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- Teléfono fijo (opcional) -->
                    <div class="">
                        <div class="input-wrapper" [class.error]="formSolicitudGen.get('telefonofijo')?.touched && formSolicitudGen.get('telefonofijo')?.errors && formSolicitudGen.get('telefonofijo')?.value">
                            <input type="tel" class="custom-input" formControlName="telefonofijo" placeholder=" "
                                inputmode="numeric" maxlength="10" pattern="[0-9]*" (keypress)="soloNumeros($event)">
                            <label class="floating-label" [attr.readonly]="isReadonly ? true : null"
                                (focus)="disableReadonly($event)">Teléfono fijo (Opcional)</label>
                            <div *ngIf="formSolicitudGen.get('telefonofijo')?.touched && formSolicitudGen.get('telefonofijo')?.errors">
                                <label class="helper-error" *ngIf="formSolicitudGen.get('telefonofijo')?.errors?.['repetidos5']">
                                    No repitas el mismo dígito más de 5 veces seguidas.
                                </label>
                                <label class="helper-error" *ngIf="formSolicitudGen.get('telefonofijo')?.errors?.['telefonoInvalido']">
                                    Ingresa el teléfono móvil a 10 dígitos.
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- Mensaje -->
                    <div class="">
                        <div class="input-wrapper" style="height: 89px;">
                            <textarea class="custom-textarea" formControlName="mensaje" style="width: 100%;"
                                placeholder=" " maxlength="100"></textarea>
                            <label class="floating-label textArea-label" [attr.readonly]="isReadonly ? true : null"
                                (focus)="disableReadonly($event)">Escribe un mensaje</label>
                            <div class="form-text text-end">
                                <span class="select-indicator">{{ formSolicitudGen.get('mensaje')?.value?.length || 0
                                    }}/100</span>
                            </div>
                        </div>
                    </div>
                    <!-- Contacto por -->
                    <div class="mb-4 text-center">
                        <label class="text-campoo d-block mb-2">Recibir información a través de*</label>
                        <div class="check-options justify-content-center">
                            <div class="form-check">
                                <input type="radio" name="todos" id="correoc" class="custom-radio"
                                    formControlName="todos" value="correoc" checked>
                                <label class="form-check-label" for="correoc">Correo electrónico</label>
                            </div>
                            <div class="form-check">
                                <input type="radio" name="todos" id="telefono" class="custom-radio"
                                    formControlName="todos" value="telefono">
                                <label class="form-check-label" for="telefono">Teléfono</label>
                            </div>
                            <div class="form-check">
                                <input type="radio" name="todos" id="ambos" class="custom-radio" formControlName="todos"
                                    value="ambos">
                                <label class="form-check-label" for="ambos">Ambos</label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 pt-4">
                        <p class="text-campoo">Los campos marcados con (<span>*</span>) son obligatorios.</p>
                    </div>
                    <!-- Botones -->
                    <div class="buttons-wrapper">
                        <button type="button" (click)="limpiarForm()" class="btn-cancelar" data-bs-dismiss="modal">Cancelar</button>
                        <button type="submit" class="btn-enviar me-2"
                            [disabled]="!isFormValid || enviado">Enviar</button>
                    </div>
                    <div class="scroll-bottom-padding"></div>
                </form>
            </div>
        </div>
    </div>
</div>